(function(){
'use strict';
var drawer=document.getElementById('cart-drawer');if(!drawer)return;
function money(cents){cents=Math.round(cents||0);var neg=cents<0?'-':'',e,c;cents=Math.abs(cents);e=Math.floor(cents/100);c=cents%100;return neg+'€'+String(e).replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+(c<10?'0'+c:c)}
function refresh(){var total=0;drawer.querySelectorAll('.cart-item:not(.is-removing)').forEach(function(li){var qEl=li.querySelector('.qty-num'),pEl=li.querySelector('.cart-item-price');if(!qEl||!pEl)return;var q=parseInt(qEl.tagName==='INPUT'?qEl.value:qEl.textContent,10)||0,unit=parseInt(pEl.dataset.unitPrice,10)||0;total+=unit*q});var sub=document.getElementById('cart-subtotal');if(sub)sub.textContent=money(total);var bar=drawer.querySelector('.psi-fs-bar');if(!bar)return;var thr=parseInt(bar.dataset.threshold,10)||0;if(thr<=0)return;var fill=bar.querySelector('.psi-fs-fill');if(fill)fill.style.width=Math.min(100,Math.round(total*100/thr))+'%';var txt=bar.querySelector('.psi-fs-text');if(total>=thr){bar.classList.add('psi-fs-done');if(txt)txt.innerHTML='✓ Hai ottenuto la <b>spedizione gratuita</b>'}else{bar.classList.remove('psi-fs-done');if(txt)txt.innerHTML='Ti mancano <b>'+money(thr-total)+'</b> per la <b>spedizione gratuita</b>'}}
function schedule(){requestAnimationFrame(function(){requestAnimationFrame(refresh)})}
function closeDrawer(){drawer.setAttribute('aria-hidden','true');drawer.classList.remove('open');var overlay=document.getElementById('cart-overlay');if(overlay)overlay.classList.remove('visible');document.body.classList.remove('cart-open')}
drawer.addEventListener('click',function(e){var t=e.target&&e.target.closest?e.target.closest('.qty-btn,#cart-continue'):null;if(!t)return;if(t.id==='cart-continue'){e.preventDefault();closeDrawer();return}if(t.classList.contains('qty-btn'))schedule()});
drawer.addEventListener('change',function(e){if(e.target.classList&&e.target.classList.contains('qty-num'))schedule()});
drawer.addEventListener('keyup',function(e){if(e.key==='Enter'&&e.target.classList&&e.target.classList.contains('qty-num'))schedule()});

/* PSI v410 - conferma aggiunta al carrello in stile bottom sheet.
   Il drawer completo resta disponibile quando il cliente apre volontariamente il carrello. */
var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
var pendingAdd=null,pendingTimer=null,previousFocus=null,confirmationRequest=0;
var style=document.createElement('style');
style.id='psi-cart-confirm-style';
style.textContent=
'#psi-cart-confirm{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:flex-end;justify-content:center;pointer-events:none;visibility:hidden;font-family:inherit}'+
'#psi-cart-confirm.is-open{pointer-events:auto;visibility:visible}'+
'.psi-cart-confirm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.34);opacity:0;transition:opacity .22s ease}'+
'#psi-cart-confirm.is-open .psi-cart-confirm-backdrop{opacity:1}'+
'.psi-cart-confirm-sheet{position:relative;width:100%;max-height:min(82dvh,760px);overflow:auto;overscroll-behavior:contain;background:#fff;color:#111;border-radius:28px 28px 0 0;padding:28px 24px calc(46px + env(safe-area-inset-bottom));box-shadow:0 -12px 44px rgba(0,0,0,.12);transform:translate3d(0,104%,0);transition:transform .26s cubic-bezier(.22,.8,.3,1);-webkit-overflow-scrolling:touch}'+
'#psi-cart-confirm.is-open .psi-cart-confirm-sheet{transform:translate3d(0,0,0)}'+
'.psi-cart-confirm-head{display:flex;align-items:center;gap:14px;padding-right:56px;min-height:44px}'+
'.psi-cart-confirm-check{display:grid;place-items:center;flex:0 0 25px;width:25px;height:25px;border-radius:50%;background:#0b8f55;color:#fff}'+
'.psi-cart-confirm-check svg{width:13px;height:13px}'+
'.psi-cart-confirm-title{margin:0;font-size:18.5px;line-height:1.18;font-weight:700;letter-spacing:-.022em}'+
'.psi-cart-confirm-close{position:absolute;top:22px;right:22px;display:grid;place-items:center;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:transparent;color:#111;cursor:pointer;-webkit-tap-highlight-color:transparent}'+
'.psi-cart-confirm-close:before{content:"";position:absolute;width:39px;height:39px;border-radius:50%;background:#f5f5f5}'+
'.psi-cart-confirm-close svg{position:relative;z-index:1;width:19px;height:19px}'+
'.psi-cart-confirm-product{display:grid;grid-template-columns:112px minmax(0,1fr);gap:20px;margin-top:24px;align-items:start}'+
'.psi-cart-confirm-media{width:112px;height:132px;background:#f5f5f5;overflow:hidden}'+
'.psi-cart-confirm-media[hidden]{display:none}'+
'.psi-cart-confirm-media img{display:block;width:100%;height:100%;object-fit:contain}'+
'.psi-cart-confirm-product.no-image{grid-template-columns:1fr}'+
'.psi-cart-confirm-info{min-width:0;padding-top:4px}'+
'.psi-cart-confirm-product-title{margin:0 0 8px;font-size:15.8px;line-height:1.28;font-weight:650;letter-spacing:-.015em}'+
'.psi-cart-confirm-meta{display:grid;gap:3px;margin:0 0 7px;color:#707070;font-size:14.1px;line-height:1.32}'+
'.psi-cart-confirm-price{margin:8px 0 0;font-size:15.8px;line-height:1.25;font-weight:500}'+
'.psi-cart-confirm-actions{display:grid;gap:12px;margin-top:28px}'+
'.psi-cart-confirm-action{display:flex;align-items:center;justify-content:center;min-height:60px;padding:12px 20px;border-radius:999px;text-decoration:none!important;font-size:17px;line-height:1.1;font-weight:700;letter-spacing:-.012em;-webkit-tap-highlight-color:transparent}'+
'.psi-cart-confirm-cart{border:1.5px solid #d0d0d0;background:#fff;color:#111}'+
'.psi-cart-confirm-checkout{border:1.5px solid #111;background:#111;color:#fff}'+
'button,a,summary,[role="button"],input[type="button"],input[type="submit"]{touch-action:manipulation}'+
'body.psi-cart-confirm-open{overflow:hidden}'+
'body.psi-cart-confirm-open .joinchat,body.psi-cart-confirm-open .joinchat__button,body.psi-cart-confirm-open .floating-wpp,body.psi-cart-confirm-open .wa__btn_popup,body.psi-cart-confirm-open [class*="whatsapp"],body.psi-cart-confirm-open [class*="WhatsApp"],body.psi-cart-confirm-open [id*="whatsapp"],body.psi-cart-confirm-open [id*="WhatsApp"],body.psi-cart-confirm-open a[href*="wa.me"],body.psi-cart-confirm-open a[href*="api.whatsapp.com"],body.psi-cart-confirm-open [aria-label*="WhatsApp"],body.psi-cart-confirm-open [aria-label*="whatsapp"],body.psi-cart-confirm-open [title*="WhatsApp"],body.psi-cart-confirm-open iframe[src*="whatsapp"]{opacity:0!important;visibility:hidden!important;pointer-events:none!important}'+
'@media (min-width:769px){#psi-cart-confirm{padding:24px}.psi-cart-confirm-sheet{width:min(620px,calc(100vw - 48px));border-radius:28px;padding:30px 30px 28px}.psi-cart-confirm-close{top:24px;right:28px}.psi-cart-confirm-actions{grid-template-columns:1fr 1fr}.psi-cart-confirm-action{min-height:60px}}'+
'@media (max-width:420px){.psi-cart-confirm-sheet{padding-left:20px;padding-right:20px;padding-bottom:calc(52px + env(safe-area-inset-bottom))}.psi-cart-confirm-title{font-size:17.6px}.psi-cart-confirm-product{grid-template-columns:96px minmax(0,1fr);gap:17px}.psi-cart-confirm-media{width:96px;height:116px}.psi-cart-confirm-product-title,.psi-cart-confirm-price{font-size:15px}.psi-cart-confirm-meta{font-size:14.1px}.psi-cart-confirm-action{font-size:17px}}'+
'@media (prefers-reduced-motion:reduce){.psi-cart-confirm-backdrop,.psi-cart-confirm-sheet{transition-duration:.01ms}}';
document.head.appendChild(style);

/* PSI v410 - nessun ritardo artificiale sui link interni. theme.js applica
   una transizione di uscita da 240 ms salvo data-no-transition: lo impostiamo
   in capture prima che il gestore globale possa bloccare la navigazione. */
document.addEventListener('click',function(e){
  var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;
  if(!a)return;
  var href=a.getAttribute('href')||'';
  if(!href||href.charAt(0)==='#'||href.indexOf('javascript:')===0)return;
  if((a.target&&a.target!=='_self')||a.hasAttribute('download'))return;
  try{
    var url=new URL(a.href,location.href);
    if(url.origin!==location.origin)return;
    a.setAttribute('data-no-transition','')
  }catch(err){}
},true);

var shell=document.createElement('div');
shell.id='psi-cart-confirm';
shell.setAttribute('aria-hidden','true');
shell.innerHTML=
'<div class="psi-cart-confirm-backdrop" data-psi-cart-close></div>'+
'<section class="psi-cart-confirm-sheet" role="dialog" aria-modal="true" aria-labelledby="psi-cart-confirm-title">'+
  '<div class="psi-cart-confirm-head">'+
    '<span class="psi-cart-confirm-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4.2 4.2L19 6.5"/></svg></span>'+
    '<h2 class="psi-cart-confirm-title" id="psi-cart-confirm-title">Aggiunto al carrello</h2>'+
  '</div>'+
  '<button class="psi-cart-confirm-close" type="button" aria-label="Chiudi" data-psi-cart-close><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'+
  '<div class="psi-cart-confirm-product">'+
    '<div class="psi-cart-confirm-media"><img alt="" width="224" height="264"></div>'+
    '<div class="psi-cart-confirm-info">'+
      '<p class="psi-cart-confirm-product-title"></p>'+
      '<div class="psi-cart-confirm-meta"></div>'+
      '<p class="psi-cart-confirm-price"></p>'+
    '</div>'+
  '</div>'+
  '<div class="psi-cart-confirm-actions">'+
    '<a class="psi-cart-confirm-action psi-cart-confirm-cart" data-no-transition href="'+root+'cart">Visualizza carrello</a>'+
    '<a class="psi-cart-confirm-action psi-cart-confirm-checkout" data-no-transition href="/checkout">Pagamento</a>'+
  '</div>'+
'</section>';
document.body.appendChild(shell);

var media=shell.querySelector('.psi-cart-confirm-media');
var img=media.querySelector('img');
var product=shell.querySelector('.psi-cart-confirm-product');
var productTitle=shell.querySelector('.psi-cart-confirm-product-title');
var meta=shell.querySelector('.psi-cart-confirm-meta');
var price=shell.querySelector('.psi-cart-confirm-price');
var cartLink=shell.querySelector('.psi-cart-confirm-cart');
var closeButton=shell.querySelector('.psi-cart-confirm-close');

function clearPending(){
  if(pendingTimer){clearTimeout(pendingTimer);pendingTimer=null}
  pendingAdd=null
}
function markPending(btn){
  var variantId='';
  if(btn.dataset&&btn.dataset.variantId)variantId=btn.dataset.variantId;
  if(!variantId&&btn.id==='add-to-cart-btn'){
    var selected=document.getElementById('selected-variant-id');
    if(selected)variantId=selected.value
  }
  if(!variantId){
    var form=btn.closest&&btn.closest('form');
    var idInput=form&&form.querySelector('[name="id"]');
    if(idInput)variantId=idInput.value
  }
  pendingAdd={
    variantId:String(variantId||''),
    title:(btn.dataset&&btn.dataset.productTitle)||'',
    trigger:btn
  };
  if(pendingTimer)clearTimeout(pendingTimer);
  pendingTimer=setTimeout(clearPending,8000)
}
document.addEventListener('click',function(e){
  var target=e.target&&e.target.closest?e.target:null;
  if(!target)return;
  if(target.closest('#cart-toggle')){clearPending();return}
  var btn=target.closest('.btn-add-to-cart[data-variant-id],#add-to-cart-btn,[data-add-cart],button[name="add"],input[name="add"]');
  if(!btn||btn.closest('#cart-drawer')||btn.id==='buy-now-btn'||btn.closest('[data-psi-buy]'))return;
  if(btn.disabled||btn.classList.contains('loading'))return;
  markPending(btn)
},true);

function hideLegacyNotification(){
  var note=document.getElementById('cart-notification');
  if(note){note.classList.remove('show');note.textContent=''}
}
function formatPrice(cents,currency){
  try{return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency:currency||'EUR'}).format((Number(cents)||0)/100)}
  catch(e){return money(cents)}
}
function optionLines(item){
  var lines=[];
  if(item&&Array.isArray(item.options_with_values)){
    item.options_with_values.forEach(function(opt){
      if(!opt||!opt.value||opt.value==='Default Title')return;
      lines.push((opt.name?opt.name+' ':'')+opt.value)
    })
  }else if(item&&item.variant_title&&item.variant_title!=='Default Title'){
    lines.push(item.variant_title)
  }
  if(item&&Number(item.quantity)>1)lines.push('Quantità '+item.quantity);
  return lines
}
function renderConfirmation(cart,ctx){
  var item=null;
  var items=cart&&Array.isArray(cart.items)?cart.items:[];
  if(ctx.variantId){
    item=items.find(function(row){return String(row.variant_id)===ctx.variantId})||null
  }else if(items.length===1){
    item=items[0]
  }
  var title=(item&&(item.product_title||item.title))||ctx.title||'Prodotto aggiunto al carrello';
  productTitle.textContent=title;

  var imageUrl='';
  if(item){
    imageUrl=(item.featured_image&&item.featured_image.url)||item.image||''
  }
  if(imageUrl){
    img.loading='eager';
    img.decoding='async';
    img.setAttribute('fetchpriority','high');
    img.src=imageUrl;
    img.alt=title;
    media.hidden=false;
    product.classList.remove('no-image')
  }else{
    img.removeAttribute('src');
    img.alt='';
    media.hidden=true;
    product.classList.add('no-image')
  }

  meta.textContent='';
  optionLines(item).forEach(function(line){
    var row=document.createElement('span');
    row.textContent=line;
    meta.appendChild(row)
  });
  meta.hidden=!meta.childNodes.length;

  if(item&&typeof item.final_price!=='undefined'){
    price.textContent=formatPrice(item.final_price,cart&&cart.currency);
    price.hidden=false
  }else{
    price.textContent='';
    price.hidden=true
  }

  var count=cart&&typeof cart.item_count!=='undefined'?Number(cart.item_count):parseInt((document.getElementById('cart-count')||{}).textContent,10);
  cartLink.textContent='Visualizza carrello'+(isFinite(count)&&count>0?' ('+count+')':'')
}
function waitForConfirmationImage(){
  if(media.hidden||!img.getAttribute('src'))return Promise.resolve();
  function decodeImage(){
    if(typeof img.decode!=='function')return Promise.resolve();
    return img.decode().catch(function(){})
  }
  if(img.complete){
    if(img.naturalWidth>0)return decodeImage();
    media.hidden=true;
    product.classList.add('no-image');
    return Promise.resolve()
  }
  return new Promise(function(resolve){
    var settled=false;
    function finish(ok){
      if(settled)return;
      settled=true;
      img.removeEventListener('load',onLoad);
      img.removeEventListener('error',onError);
      if(!ok){
        media.hidden=true;
        product.classList.add('no-image');
        resolve();
        return
      }
      decodeImage().then(resolve)
    }
    function onLoad(){finish(true)}
    function onError(){finish(false)}
    img.addEventListener('load',onLoad,{once:true});
    img.addEventListener('error',onError,{once:true})
  })
}
function openConfirmation(ctx){
  if(shell.classList.contains('is-open'))return;
  previousFocus=ctx.trigger||document.activeElement;
  shell.setAttribute('aria-hidden','false');
  shell.classList.add('is-open');
  document.body.classList.add('psi-cart-confirm-open');
  try{closeButton.focus({preventScroll:true})}catch(e){closeButton.focus()}
}
function showConfirmation(ctx){
  var request=++confirmationRequest;
  fetch(root+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
    .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
    .then(function(cart){
      if(request!==confirmationRequest)return;
      renderConfirmation(cart,ctx);
      return waitForConfirmationImage().then(function(){
        if(request!==confirmationRequest)return;
        openConfirmation(ctx)
      })
    })
    .catch(function(){
      if(request!==confirmationRequest)return;
      renderConfirmation(null,ctx);
      openConfirmation(ctx)
    })
}
function closeConfirmation(){
  if(!shell.classList.contains('is-open'))return;
  shell.classList.remove('is-open');
  shell.setAttribute('aria-hidden','true');
  document.body.classList.remove('psi-cart-confirm-open');
  if(previousFocus&&typeof previousFocus.focus==='function'){
    try{previousFocus.focus({preventScroll:true})}catch(e){}
  }
  previousFocus=null
}
shell.addEventListener('click',function(e){
  if(e.target.closest&&e.target.closest('[data-psi-cart-close]')){e.preventDefault();closeConfirmation()}
});
document.addEventListener('keydown',function(e){
  if(!shell.classList.contains('is-open'))return;
  if(e.key==='Escape'){e.preventDefault();closeConfirmation();return}
  if(e.key!=='Tab')return;
  var focusable=Array.prototype.slice.call(shell.querySelectorAll('button:not([disabled]),a[href]')).filter(function(el){return el.offsetParent!==null});
  if(!focusable.length)return;
  var first=focusable[0],last=focusable[focusable.length-1];
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
});

var openObserver=new MutationObserver(function(){
  if(!pendingAdd)return;
  if(drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false'){
    var ctx=pendingAdd;
    clearPending();
    closeDrawer();
    hideLegacyNotification();
    showConfirmation(ctx)
  }
});
openObserver.observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
}());
